module.exports = "{{{files.0.content.html}}}\n"


//////////////////
// WEBPACK FOOTER
// ./src/data/templates/plainHtmlTemplate.html
// module id = 2206
// module chunks = 1